// Haptyka (wibracje) na telefonie. Bezpieczna: brak wsparcia = nic sie nie dzieje.
//
// `navigator.vibrate` obsluguje Android/Chrome. iOS Safari go NIE ma, a czesc
// przegladarek wymaga wczesniejszego gestu uzytkownika (u nas jest nim dotkniecie
// "Testuj na trasie"). Dlatego kazdy blad i brak wsparcia po cichu pomijamy.

export const VIBRATION: { success: number[]; failure: number[] } = {
  // Krotkie, lekkie podwojne "pyk" po wygranej.
  success: [25, 40, 60],
  // Mocniejszy, nierowny wzor po porazce.
  failure: [90, 60, 140],
};

interface Vibrator {
  vibrate?: (pattern: number | number[]) => boolean;
}

/** Wibruje wzorcem dla wyniku proby. Zwraca true, gdy wibracja zostala zlecona. */
export function vibrateOutcome(outcome: 'won' | 'failed'): boolean {
  return vibrate(outcome === 'won' ? VIBRATION.success : VIBRATION.failure);
}

/** Wibruje podanym wzorcem (ms). Brak wsparcia lub blad = ciche false. */
export function vibrate(pattern: number | number[]): boolean {
  const navigatorLike = (globalThis as { navigator?: Vibrator }).navigator;
  if (!navigatorLike || typeof navigatorLike.vibrate !== 'function') return false;

  try {
    navigatorLike.vibrate(pattern);
    return true;
  } catch {
    return false;
  }
}
